import {
  InvisibleSmartCaptcha,
  InvisibleSmartCaptchaProps,
} from '@yandex/smart-captcha';
import { FC } from 'react';

const YandexInvisibleCaptcha: FC<
  Omit<InvisibleSmartCaptchaProps, 'sitekey'>
> = (props) => {
  return (
    <InvisibleSmartCaptcha
      sitekey={process.env.NEXT_PUBLIC_API_KEY_YANDEX_CAPTCHA as string}
      {...props}
    />
  );
};

export default YandexInvisibleCaptcha;
